import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '../../common'

export const JournalEntrySearchParamsSchema = z
  .object({
    q: z.string().optional(),
    fiscalPeriodId: z.coerce.number().optional(),
    status: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type JournalEntrySearchParams = z.infer<
  typeof JournalEntrySearchParamsSchema
>

export const JournalEntrySearchResultModelSchema = z.object({
  id: z.number(),
  entryNumber: z.string(),
  entryDate: z.string(),
  postingDate: z.string(),
  description: z.string().nullable(),
  status: z.string(),
  totalDebit: z.number(),
  totalCredit: z.number(),
})

export type JournalEntrySearchResultModel = z.infer<
  typeof JournalEntrySearchResultModelSchema
>

export const JournalEntrySearchResultSchema = z
  .object({
    data: z.array(JournalEntrySearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type JournalEntrySearchResult = z.infer<
  typeof JournalEntrySearchResultSchema
>
